module.exports = __webpack_public_path__ + "img/anquan_gaoji.7232aa64.png";